// extracted by mini-css-extract-plugin
export default {"overlay":"cB-z","bodyOpen":"dB-z","content":"eB-z","header":"fB-z","close":"gB-z","closeNoHeading":"hB-z"};